var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.page == "competition")?_c('competition'):_vm._e(),_vm._v(" "),(_vm.page == "auction")?_c('auction'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }